<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :delete_url="delete_url"
      :urls="urls"
      ref="datatable"
      :actionsComponent="null"
    >
      <template v-slot:rowActions="{ item, permissions }">
        <v-menu left transition="scale-transition" offset-y bottom rounded>
          <template v-slot:activator="{ on, attrs }">
            <a
              v-bind="attrs"
              v-on="on"
              class="btn btn-light-light btn-hover-info show poppins min-w-100px min-w-md-110px"
            >
              Actions
              <span class="svg-icon svg-icon-5 m-0">
                <v-icon small>mdi-chevron-down</v-icon>
              </span>
            </a>
          </template>
          <v-card class="poppins py-1" elevation="1">
            <div v-if="permissions('update')">
              <v-btn
                class="w-100 text-left"
                @click="
                  () => {
                    $refs.datatable.editItem(item);
                  }
                "
                text
                >Edit
              </v-btn>
            </div>

            <div v-if="permissions('update') && isNotCorePlan(item)">
              <EditPages
                :refresher="$refs?.datatable?.updateTableContent"
                :pageLoader="$refs?.datatable?.pageLoad"
                ref="editPages"
              />
              <v-btn
                class="w-100 text-left"
                @click="
                  () => {
                    $refs.editPages.loadDataFromServer(item.id);
                  }
                "
                text
                >Edit pages
              </v-btn>
            </div>

            <div v-if="permissions('destroy') && isNotCorePlan(item)">
              <v-btn
                class="w-100 text-left"
                @click="
                  () => {
                    $refs.datatable.removeItem(item);
                  }
                "
                text
                >Delete
              </v-btn>
            </div>
          </v-card>
        </v-menu>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import ActionsDialog from "@/own/components/orderManagement/subscriptionPlans/ActionDialog.vue";
import EditPages from "@/own/components/orderManagement/subscriptionPlans/EditPages.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PER_PAGE,
  SET_TABLE_SORT_BY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/subscriptionPlans.module";

export default {
  name: "SubscriptionPlans",
  components: { DataTable, EditPages },
  data: () => ({
    componentForEditing: ActionsDialog,
    componentForAdding: ActionsDialog,
    delete_url: `${process.env.VUE_APP_BASE_URL}/order_management/subscription_plans/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORT_BY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PER_PAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getSUBSCRIPTIONPLANSTableFilters",
      getTableState: "getSUBSCRIPTIONPLANSTableState",
      getTableData: "getSUBSCRIPTIONPLANSTableData",
      getTableHeaders: "getSUBSCRIPTIONPLANSTableHeaders",
      getTableProperties: "getSUBSCRIPTIONPLANSTableProperties",
      getTableExportUrl: "getSUBSCRIPTIONPLANSExportUrl",
      getTablePermissions: "getSUBSCRIPTIONPLANSTablePermissions",
    },
    urls: {
      status: `${process.env.VUE_APP_BASE_URL}/order_management/subscription_plans/status`,
    },
  }),
  methods: {
    isNotCorePlan(item) {
      if (item.name === "IQ Core" && item.id === 1) return false;
      else return true;
    },
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
